import React, { Component }         from 'react'
import { connect }                  from 'react-redux';
import {Field, reduxForm, reset}    from 'redux-form';
import moment                       from 'moment';
import $                            from 'jquery';
import Lightbox                     from 'react-images';
import { GetTipoMidiaPost,
         GetComentariosPostTurma,
         GetRemoverComentarioEquipe,
         SetComentarioPost
        }                           from '../../../../actions/turmaAction';
import ComentarioPost               from '../../../../container/renderComentarioPost';
import RenderAvatarP                from '../../../../container/render_avatar_p';
import BtAcaoComentario             from '../../../../container/btAcaoRemoverItem';
import validate                     from '../../../../service/validate_nave';

import '../../../../css/aluno/box.css';


const renderField = ({ input, label,length, type, placeholder,value,meta: { touched, error } }) => (

    <textarea 
            className="form-control" 
            rows="2"
            placeholder={placeholder} 
            {...input}></textarea>
)

class Tripulacao_Comentario extends Component {

    constructor(props) {
        super(props);
        this.state = {
            load              : false,
            loadComentario    : false,
            buttonDisabledCom : false,
            comentariosPost   : [],
            tur_pos_tipo      : this.props.ItemPostTimeline.tur_pos_tipo,
            tur_pos_midia     : this.props.ItemPostTimeline.tur_pos_midia,
            midia             : <div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(this.props.ItemPostTimeline)}} />,
            tur_pos_id        : this.props.ItemPostTimeline.tur_pos_id,
            use_foto          : this.props.ItemPostTimeline.use_foto,
            use_nome          : this.props.ItemPostTimeline.use_nome,
            created_at        : this.props.ItemPostTimeline.created_at,
            tur_pos_post      : this.props.ItemPostTimeline.tur_pos_post,
            num_like          : this.props.ItemPostTimeline.num_like,
            use_id            : this.props.session.id,
            lightboxIsOpen    : false
        }
  
    }

    componentWillMount(){
      this.props.GetComentariosPostTurma(this.state.tur_pos_id);
      this.renderTextArea();
    }

    renderTextArea(){

        $('textarea').each(function () {
            this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
          }).on('input', function () {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
          });

          $(".container-button-enviar").click(function(event){
            $( "textarea" ).focus();

        })
    }

    exclusaoComentarioPost(elem){
      this.props.GetRemoverComentarioEquipe(this.state.use_id,elem);
    }

    handleSubmit(e) {
      this.props.SetComentarioPost(this.state,e.comentario).then((response)=>{
        $('textarea').css('height','28px')
      })
      
    }

    getComentariosPost(){
     
            if (this.props.comentarios) {
                const dados = this.props.comentarios;
                return dados.map((elem, i) => {
                    return <ComentarioPost
                            id         = {elem.tur_com_pos_id}
                            foto       = {elem.use_foto}
                            nome       = {elem.use_nome}
                            key        = {i}
                            funcao     = {<BtAcaoComentario funcao={this.exclusaoComentarioPost.bind(this,elem)}/>}
                            use_id     = {this.props.session.id}
                            use_id_com = {elem.tur_com_pos_cod_usuario}
                            coment     = {elem.tur_com_pos_comentario}
                            />;
                    });

                }else{
                    return "";
                }
    }

    closeLightbox(){
       this.setState({lightboxIsOpen:false})
    }
      
    openImg(){
      this.setState({lightboxIsOpen:true})
    }

    render() {
        const {handleSubmit}  = this.props;
        const renderTipoMidia = (this.state.tur_pos_tipo === 2 ? <a href={void(0)} className="ligthBoxPost" onClick={this.openImg.bind(this)}>
        {this.state.midia}
        {this.state.tur_pos_midia? <Lightbox images  = {[{ src: this.state.tur_pos_midia }]} isOpen  = {this.state.lightboxIsOpen} onClose = {this.closeLightbox.bind(this)}  /> : ""}
      </a>: this.state.midia);
      

        return ( <div className="box box-fixed" data-reference=".hud-middle-center-content">
                        <div className="box-header">
                            <div className="box-header-decoration"></div>
                            <div className="box-header-info">
                                <div className="box-header-info-tools">
                                    <a href={void(0)} className="simple-action" onClick={this.props.funcao}>&times;</a>
                                </div>
                            </div>
                        </div>
                        <div className="box-body">
                            <div className="communication communication-paneless communication-transparent communication-for-comment">
                                <div className="communication-message for-comment">
                                    <div className="author author-with-link author-with-line author-with-line-half">
                                        <div className="author-name">
                                            {this.props.ItemPostTimeline.use_nome}
                                        </div>
                                        <div className="author-avatar">
                                            <RenderAvatarP Foto={this.props.ItemPostTimeline.use_foto} />
                                        </div>
                                    </div>
                                    <div className="communication-message-content communication-container-box communication-container-box-fluid">
                                        <div className="communication-container-box-left">
                                            <small>{this.props.ItemPostTimeline.tur_pos_post}</small>
                                            {renderTipoMidia}
                                            <div className="communication-container-box-actions">
                                                <div className="communication-container-box-tools">
                                                    <a href={void(0)} className="action action-icon action-simple action-labeled">
                                                        <i className="gamefica-icon gamefica-heart"></i>
                                                        <span>+{this.props.ItemPostTimeline.num_like}</span>
                                                    </a>
                                                    <a href={void(0)} className="action action-icon action-simple action-labeled">
                                                        <i className="gamefica-icon gamefica-balloon"></i>
                                                        <span>+{this.props.ItemPostTimeline.qtd_comentarios}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="communication-container-box-offright">
                                            <div className="communication-container-box-offright-item communication-container-box-offright-item-90"></div>
                                            <div className="communication-container-box-offright-item communication-container-box-offright-item-70"></div>
                                            <div className="communication-container-box-offright-item communication-container-box-offright-item-40"></div>
                                            <div className="communication-container-box-offright-item communication-container-box-offright-item-20">
                                                {moment(this.props.ItemPostTimeline.created_at).format("DD/MM/YYYY")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="communication-new for-comment">
                                    <div className="author author-with-link">
                                        <div className="author-avatar">
                                            <RenderAvatarP Foto={this.props.session.foto} />
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit(this.handleSubmit.bind(this))} className="communication-new-input communication-container-box">
                                        <div className="communication-container-box-left">
                                            <Field name="comentario" type="text" component={renderField} placeholder="Escreva um comentário..." label="" />
                                        </div>
                                        <div className="communication-container-box-right">
                                            <div className="communication-container-box-info">DS214536899777</div>
                                            <div className="communication-container-box-actions">
                                                <button type="submit" onClick={this.setComentarioPost} className="communication-container-box-action">
                                                    <span>Enviar</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="communication-comments hud-scroll-tip">
                                    {this.getComentariosPost()}
                                </div>
                            </div>
                        </div>
                    </div>)
    }
}

function mapStateToProps(state) {
    return {
        session     : state.auth.session,
        comentarios : state.turmaReducer.allComentPost
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('comentario_tripulacao'));

export default reduxForm({
   form                     : 'comentario_tripulacao', 
   destroyOnUnmount         : true,
   forceUnregisterOnUnmount : true, 
   onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps,{GetTipoMidiaPost, GetRemoverComentarioEquipe, GetComentariosPostTurma, SetComentarioPost})(Tripulacao_Comentario));



// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/tripulacao/tripulacao_comentario.js